export default __webpack_public_path__ + "fdcbde68243dfb20c871754468a5d725.png";